var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-fat-radio-group",attrs:{"role":"radiogroup"}},[_vm._l((_vm.items),function(item){return [_vm._t("default",null,{"item":item,"active":Array.isArray(_vm.value)
        ? _vm.value.includes(item.value)
        : _vm.value === item.value,"keydown":_vm.keydown})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }